<template>
  <v-dialog v-model="value" width="600" persistent>
    <v-form v-model="valid" ref="form">
      <v-card class="w-100 rounded-lg">
        <v-card-title>{{ $t('spedilink.persons.edit') }}</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="form.firstName"
            :label="$t('spedilink.persons.firstName')"
            outlined
            dense
            class="mb-2"
            :rules="requiredRules"
          />
          <v-text-field
            v-model="form.lastName"
            :label="$t('spedilink.persons.lastName')"
            outlined
            dense
            class="mb-2"
            :rules="requiredRules"
          />
          <v-text-field
            :value="person.email"
            :label="$t('spedilink.persons.email')"
            outlined
            dense
            class="mb-2"
            disabled
          />
          <v-text-field
            v-model="form.phone"
            :label="$t('spedilink.persons.phone')"
            outlined
            dense
            class="mb-2"
          />
        </v-card-text>
        <v-card-actions class="d-flex justify-end px-4 pb-4">
          <v-btn outlined :disabled="loading" @click="close()">
            {{ $t('common.cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            class="ml-2"
            :loading="loading"
            :disabled="loading"
            depressed
            @click="save()"
          >
            {{ $t('common.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import Service from '@/services'

export default {
  name: 'EditSpediLinkPersonDialog',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    person: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      valid: true,
      loading: false,
      form: {
        firstName: '',
        lastName: '',
        phone: ''
      },
      requiredRules: [
        (v) => !!v || this.$t('validation.fieldRequired')
      ]
    }
  },
  methods: {
    open () {
      this.form.firstName = this.person.firstName
      this.form.lastName = this.person.lastName
      this.form.phone = this.person.phone || ''
    },
    close () {
      this.$emit('close')
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },
    async save () {
      this.$refs.form.validate()
      if (!this.valid) return

      this.loading = true
      try {
        await Service.put('spedilink/SpediLinkUsers/Update', {
          id: this.person.id,
          firstName: this.form.firstName,
          lastName: this.form.lastName,
          phone: this.form.phone || undefined
        })
        await this.$store.dispatch('setSuccessNotification', this.$t('common.confirmOperation'))
        this.$emit('person-edited')
        if (this.$refs.form) {
          this.$refs.form.resetValidation()
        }
      } catch (e) {
      } finally {
        this.loading = false
      }
    }
  },
  watch: {
    value (newVal) {
      if (newVal) {
        this.open()
      }
    }
  }
}
</script>
